"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionOrGroupType = exports.OptionGroupType = exports.OptionType = exports.ValueType = exports.SingleValueType = void 0;

var _iconName = require("../utils/propTypes/iconName");

var _propTypes = _interopRequireDefault(require("prop-types"));

var SingleValueType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]);

exports.SingleValueType = SingleValueType;

var ValueType = _propTypes.default.oneOfType([SingleValueType, _propTypes.default.arrayOf(SingleValueType)]);

exports.ValueType = ValueType;

var OptionType = _propTypes.default.shape({
  avatar: _propTypes.default.node,
  badge: _propTypes.default.object,
  buttonText: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  dropdownClassName: _propTypes.default.string,
  dropdownText: _propTypes.default.node,
  icon: (0, _iconName.getIconNamePropType)(),
  help: _propTypes.default.node,
  imageUrl: _propTypes.default.string,
  loading: _propTypes.default.bool,
  tag: _propTypes.default.object,
  tagUse: _propTypes.default.string,
  text: _propTypes.default.string,
  title: _propTypes.default.string,
  value: SingleValueType
});

exports.OptionType = OptionType;

var OptionGroupType = _propTypes.default.shape({
  dropdownClassName: _propTypes.default.string,
  dropdownText: _propTypes.default.node,
  emptyMessage: _propTypes.default.string,
  options: _propTypes.default.arrayOf(OptionType.isRequired).isRequired,
  text: _propTypes.default.string,
  title: _propTypes.default.string
});

exports.OptionGroupType = OptionGroupType;

var OptionOrGroupType = _propTypes.default.oneOfType([OptionGroupType, OptionType]);

exports.OptionOrGroupType = OptionOrGroupType;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/types/OptionTypes.js
// module id = 172
// module chunks = 5 6